// extracted by mini-css-extract-plugin
module.exports = {"className":"textBodySStrong_className__jb4Et"};